import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { InfoMessageTypeEnum } from '@websky/graphql';
import { SelectedOrderServiceStatus } from '@entities/order';
import { ThemeProvider, useTheme } from '../../../../../../theme';
import Notification from '../../../../../../Notification';

interface Props {
	status: SelectedOrderServiceStatus;
}

const CardExtraSummaryNotification: React.FC<Props> = ({ status }) => {
	const { t } = useTranslation('Cart');
	const { CardExtraSummaryNotification: theme } = useTheme('Shared').CardExtraView;

	const isUnconfirmed = status === 'unconfirmed';

	const messageStatus = isUnconfirmed ? InfoMessageTypeEnum.Warning : InfoMessageTypeEnum.Info;
	const message = t(
		isUnconfirmed
			? 'The service you have added cannot be activated. Try connecting later or contact the airline operator.'
			: 'The service is awaiting confirmation. Do not close or refresh the window.'
	);

	return (
		<ThemeProvider
			value={{
				Notification: {
					Notification: {
						wrapper: theme.wrapper,
						context: theme.context,
						warning: theme.warning,
						info: theme.info,
						text: theme.text
					}
				}
			}}
		>
			<Notification
				type="context"
				status={messageStatus}
				infoMessage={{
					text: message,
					type: messageStatus,
					code: `${status}-services`
				}}
				hideIcon
			/>
		</ThemeProvider>
	);
};

export default CardExtraSummaryNotification;
